import React from "react";
import Image from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";

const FLAGS_BASE_URL = "https://prod-static-assets.amberstudent.com/assets/flags";

const SUPPORTED_CODES = new Set([
  "ad",
  "ae",
  "af",
  "ag",
  "al",
  "am",
  "ao",
  "ar",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "eng",
  "er",
  "es",
  "et",
  "eu",
  "fi",
  "fj",
  "fk",
  "fo",
  "fr",
  "ga",
  "gb",
  "gd",
  "ge",
  "gg",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "im",
  "in",
  "iq",
  "ir",
  "is",
  "it",
  "je",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "ne",
  "ng",
  "ni",
  "nl",
  "no",
  "np",
  "nr",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sct",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vi",
  "vn",
  "vu",
  "wls",
  "ws",
  "xk",
  "ye",
  "za",
  "zm",
  "zw",
]);

interface CountryFlagProps {
  countryCode: string;
  className?: string;
  width?: number | string;
  height?: number | string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({
  countryCode,
  className,
  width = 24,
  height = 24,
}) => {
  const code = countryCode?.toLowerCase();

  if (!code || !SUPPORTED_CODES.has(code)) {
    return null;
  }

  const src = `${FLAGS_BASE_URL}/${code}.svg`;

  return (
    <Image src={src} alt={`${code} flag`} width={width} height={height} className={className} />
  );
};

export default wrapperHOC(CountryFlag, {
  componentName: "CountryFlag",
  showForChina: true,
});
